import type { JobDetailsDataLayer } from 'src/analytics/adapter/recommendedJobs';
import type { GetJobDetailsQuery } from 'src/graphql/graphql';
import type {
  JobProfileMissingSalaryPreference,
  JobProfileSalaryMatch,
  SalaryMatch,
} from 'src/queries/types';

export const isJobProfileSalaryMatch = (
  salaryMatch: SalaryMatch,
): salaryMatch is JobProfileSalaryMatch =>
  salaryMatch?.__typename === 'JobProfileSalaryMatch';

export const isJobProfileMissingSalaryPreference = (
  salaryMatch: SalaryMatch,
): salaryMatch is JobProfileMissingSalaryPreference =>
  salaryMatch?.__typename === 'JobProfileMissingSalaryPreference';

export const mapChaliceJobtoDataLayer = ({
  jobDetails,
  selectedJobListingPosition,
}: {
  jobDetails: NonNullable<NonNullable<GetJobDetailsQuery>['jobDetails']>;
  selectedJobListingPosition?: number;
}): JobDetailsDataLayer => {
  const { companyProfile, job, personalised } = jobDetails || {};

  const {
    advertiser,
    contactMatches,
    id,
    isLinkOut,
    listedAt,
    products,
    title,
    tracking,
    salary,
    status,
    workTypes,
  } = job || {};

  const jobBadges = products?.displayTags?.map((tag) => tag.label) || [];

  const {
    adProductType,
    classificationInfo,
    isPrivateAdvertiser,
    hasRoleRequirements,
    locationInfo,
  } = tracking || {};

  return {
    seekAdvertiserId: advertiser?.id,
    advertiserName: advertiser?.name,
    ...(companyProfile && {
      companyId: companyProfile?.id,
      companyName: companyProfile?.name,
      companyRating:
        companyProfile?.reviewsSummary?.overallRating?.value?.toString(),
    }),
    isSalaryMatch: Boolean(isJobProfileSalaryMatch(personalised?.salaryMatch)),
    isAddSalaryPrefNudgeShow: Boolean(
      isJobProfileMissingSalaryPreference(personalised?.salaryMatch),
    ),
    isPrivateAdvertiser: Boolean(isPrivateAdvertiser),
    isStrongApplicantBadgeShown: Boolean(personalised?.topApplicantBadge2),
    jobBadges,
    jobContacts: contactMatches?.map((c) => c.type),
    jobId: id,
    jobIsLinkOut: isLinkOut,
    jobHasRoleRequirements: Boolean(hasRoleRequirements),
    jobClassificationId: classificationInfo?.classificationId,
    jobClassification: classificationInfo?.classification,
    jobSubClassificationId: classificationInfo?.subClassificationId,
    jobSubClassification: classificationInfo?.subClassification,
    jobArea: locationInfo?.area,
    jobLocation: locationInfo?.location,
    jobListingPosition: String(selectedJobListingPosition ?? 1),
    jobListingType: adProductType,
    jobPostedTime: listedAt?.label,
    jobTitle: title,
    jobSalary: salary?.label,
    jobStatus: status,
    jobViewType: 'split',
    jobWhereId: Array.isArray(locationInfo?.locationIds)
      ? locationInfo?.locationIds[0]
      : undefined,
    jobWorkType: workTypes?.label,
  };
};
